import { render } from "./Image.vue?vue&type=template&id=4fd19a3c&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=4fd19a3c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4fd19a3c"

export default script